module.exports = __webpack_public_path__ + "media/images/404-de01af303b7b181d1fdca7b978bc441c.svg";